/* Next */
import Link from 'next/link'
import { hrefForBrandPath } from 'src/functions/navigationBreadcrumbs'

/* Types */
import { tBrand } from 'src/shared/frontendTypes/brand'

/* Options */
import config from 'src/config'

interface Props {
  brand: tBrand
}

const Brand: React.FC<Props> = ({ brand }) => {

  const logo = brand.logos?.mono
  if (!logo?.xs) return null
  
  const logoPath = `${config.image_server}/brand/${logo.xs}`
  const href = hrefForBrandPath(brand.path, brand.id) || '/brands'
  
  return <Link legacyBehavior {...{href}}>
    <a title={brand.metaTitle} >
      <img
        src={logoPath}
        alt={brand.titel}
        width={100} height={100}
        loading='eager'
      />
    </a>
  </Link>
}

export default Brand
